import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import commonIT from '@/locales/it/common.json'
import dashboardIT from '@/locales/it/dashboard.json'
import clientsIT from '@/locales/it/clients.json'
import deadlinesIT from '@/locales/it/deadlines.json'
import casesIT from '@/locales/it/cases.json'
import studioIT from '@/locales/it/studio.json'
import settingsIT from '@/locales/it/settings.json'
import billingIT from '@/locales/it/billing.json'
import badgesIT from '@/locales/it/badges.json'

void i18n.use(initReactI18next).init({
  resources: {
    it: {
      common: commonIT,
      dashboard: dashboardIT,
      clients: clientsIT,
      deadlines: deadlinesIT,
      cases: casesIT,
      studio: studioIT,
      settings: settingsIT,
      billing: billingIT,
      badges: badgesIT,
    },
  },
  lng: 'it',
  fallbackLng: 'it',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
